module.exports = __webpack_public_path__ + "static/media/Board of Studies_2022-23.653566ef.pdf";